<template>
  <b-form
    ref="overrideForm"
    novalidate
    :validated="validated">
    <b-form-group
      label="Override Date Range"
      :disabled="!canWebviewEdit"
      class="mt-4">
      <v-date-picker
        v-model="dates"
        :disabled-dates="disabledDates"
        mode="range"
        is-required>
        <b-form-input
          slot-scope="{ inputProps, inputEvents }"
          v-bind="inputProps"
          type="text"
          required
          v-on="inputEvents" />
      </v-date-picker>
    </b-form-group>
    <b-card
      title="Web View URLs"
      class="mt-0">
      <b-form-group
        label="English URL"
        :disabled="!canWebviewEdit"
        invalid-feedback="Value must be a valid URL">
        <b-form-input
          v-model="override.urls.en"
          type="url"
          :required="canWebviewEdit" />
      </b-form-group>
      <b-form-group
        label="Spanish URL"
        :disabled="!canWebviewEdit"
        invalid-feedback="Value must be a valid URL">
        <b-form-input
          v-model="override.urls.es"
          type="url"
          :required="canWebviewEdit" />
      </b-form-group>
      <b-form-group
        label="Japanese URL"
        :disabled="!canWebviewEdit"
        invalid-feedback="Value must be a valid URL">
        <b-form-input
          v-model="override.urls.ja"
          type="url"
          :required="canWebviewEdit" />
      </b-form-group>
      <b-form-group :disabled="!canWebviewEdit">
        <b-form-checkbox
          v-model="override.addAuthorizationHeader"
          switch>
          Add Authorization Header
        </b-form-checkbox>
        <template
          v-if="override.addAuthorizationHeader"
          v-slot:description>
          Clients will include the Authorization header when requesting the webview
        </template>
        <template
          v-else
          v-slot:description>
          Clients will NOT include the Authorization header when requesting the webview
        </template>
      </b-form-group>
    </b-card>
    <div class="d-flex justify-content-between mt-4">
      <template v-if="canWebviewEdit">
        <b-btn
          variant="search"
          class="xl-wide"
          @click.prevent="onCancel">
          Cancel
        </b-btn>
        <b-btn
          variant="primary"
          class="xl-wide"
          @click.prevent="onSave">
          Save
        </b-btn>
      </template>
      <b-btn
        v-else
        variant="search"
        class="xl-wide"
        @click.prevent="onCancel">
        Close
      </b-btn>
    </div>
  </b-form>
</template>

<script>
  import VDatePicker from 'v-calendar/lib/components/date-picker.umd'
  import webview from "@/services/webview"
  import _ from "lodash"
  import {mapGetters} from "vuex"

  export default {
    name: "WebViewScoreboardOverrideForm",
    components: {
      VDatePicker,
    },
    props: {
      startDate: {
        type: Date,
        default: null,
      },
      endDate: {
        type: Date,
        default: null,
      },
      config: {
        type: Object,
        default: () => ({
          ...webview.newScoreboardOverride(),
        }),
      },
      disabledDates: {
        type: Array,
        default: () => [],
      },
    },
    data: () => ({
      validated: false,
      dates: {
        start: null,
        end: null,
      },
      override: {
        ...webview.newScoreboardOverride(),
      },
    }),
    computed: {
      ...mapGetters([
        "canWebviewEdit",
      ]),
    },
    created() {
      this.override = _.cloneDeep(this.config)
      this.dates = {
        start: this.startDate,
        end: this.endDate,
      }
    },
    methods: {
      onSave() {
        this.validated = true
        const hasError = !(this.$refs.overrideForm.checkValidity())
        if (hasError) {
          this.$alert.warning("Override contains one or more errors. Please fix these errors before saving.")
          return
        }

        this.$emit("save", this.dates.start, this.dates.end, this.override)
      },
      onCancel() {
        this.$emit("cancel")
      },
    },
  }
</script>

<style scoped>

</style>
